import React from 'react'
import { Link } from 'react-router-dom'

export default props => (
    <li className="nav-item">
        <Link to={props.path}
            className={`nav-link ${props.active ? 'active' : ''} ${props.submenu ? 'submenu' : ''}`} 
            style={{
                paddingLeft: props.submenu ? 18 : null, 
                backgroundColor: props.submenu && !props.active ? '#ffffff' : null,
                fontWeight: props.submenu ? '' : 'bold'
            }}
            onClick={props.onClick}>
            <i className={`nav-icon ${props.icon}`} style={{ fontSize: props.submenu ? 13 : 16 }}></i>
			<p style={{ fontSize: props.submenu ? 13 : 16 }}>
				{props.label}
				<span class={`badge badge-${props.spanType} right`}>{props.span}</span>
			</p>
        </Link>
    </li>
)
